// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__yqsb4","type":"styles_type__2WYTj","choices":"styles_choices__25zzl"};